import styled from '@emotion/styled';

export const Container = styled.div``;

export const ClickableContainer = styled.a<{ hoverPointer?: boolean }>`
  color: inherit;

  ${({ hoverPointer }) =>
    hoverPointer &&
    `
    text-decoration: none;
    cursor: pointer;
  `};
`;
